import { useContext, useEffect, useState } from "react";

import type { MenuProps } from 'antd';
import { Dropdown } from "antd";
import { DownOutlined } from '@ant-design/icons';
import gearIcon from "../../assets/svgs/gear-solid.svg"

import ChangePasswordModal from "../../components/authentication/ChangePasswordModal";
import { AppStateContext } from "../../state/AppProvider";
import { userMe, logOut } from "../../api";
import { useSessionCookie } from '../../components/authentication/UseSessionCookie';
import { COOKIE_NAME_LOGIN_ROLE } from '../../constants/config';
import { UserRole } from "../../constants/enums";
import { useNavigate } from "react-router-dom";


const UserContextMenu: React.FC = () => {
    const appStateContext = useContext(AppStateContext)
    const [displayName, setDisplayName] = useState<string>("");
    const [changePasswordModalOpen, setChangePasswordModalOpen] = useState<boolean>(false);
    const [, setloggedInAsRole] = useSessionCookie(COOKIE_NAME_LOGIN_ROLE, undefined);
    const navigate = useNavigate()

    useEffect(() => {
        if (!appStateContext?.state.loggedInAsRole)
            window.location.href = "/login";

        const fetchDisplayName = async () => {
            const res = await userMe();
            if (res?.ok) {
                const data = await res.json();
                let user = data as User;
                setDisplayName(user.display_name ?? "");
                appStateContext?.dispatch({ type: "SET_USER_LOGIN_STATUS", payload: user.role });
            } else {
                setloggedInAsRole(undefined)
                console.log("Error fetching user info");
                appStateContext?.dispatch({ type: "SET_USER_LOGIN_STATUS", payload: undefined });
                window.location.href = "/login";
            }
        };
        fetchDisplayName();
    }, [])
    const items: MenuProps['items'] = [
        {
            label: (
                <div style={{ cursor: 'pointer' }}>
                    Change Password
                </div>
            ),
            key: 'change-password',
            className: 'c-default bg-root',
        },
        {
            type: 'divider',
            className: 'c-default bg-primary'
        },
        {
            label:
                <div style={{ cursor: 'pointer' }}>
                    Toggle Theme
                </div>,
            key: 'dark-mode',
            className: 'c-default bg-root',
        },
        {
            type: 'divider',
            className: 'c-default bg-primary'
        },
        {
            label:
                <div style={{ cursor: 'pointer' }}>
                    Logout
                </div>,
            key: 'logout',
            className: 'c-default bg-root',
        },

    ];

    if (appStateContext?.state.loggedInAsRole === UserRole.Admin) {
        if (window.location.pathname === '/admin') {
            items.unshift({
                type: 'divider',
                className: 'c-default bg-primary'
            })
            items.unshift({
                label: (
                    <div style={{ cursor: 'pointer' }}>
                        Home
                    </div>
                ),
                key: 'home',
                className: 'c-default bg-root',
            })
        } else {
            items.unshift(
                {
                    type: 'divider',
                    className: 'c-default bg-primary'
                })
            items.unshift({
                label: (
                    <div style={{ cursor: 'pointer' }}>
                        Dashboard
                    </div>
                ),
                key: 'admin-dashboard',
                className: 'c-default bg-root',
            })
        }
    }
    const handleLogout = () => {
        logOut().then((res) => {
            setloggedInAsRole(undefined)
            appStateContext?.dispatch({ type: "SET_USER_LOGIN_STATUS", payload: undefined });
            window.location.href = "/login";
        });
    }
    const handleUserMenuClick = (key: string) => {
        switch (key) {
            case 'change-password':
                setChangePasswordModalOpen(true);
                break;
            case 'logout':
                handleLogout();
                break;
            case 'dark-mode':
                document.body.classList.toggle("dark-mode");
                localStorage.setItem('darkmode', document.body.classList.contains("dark-mode") ? '1' : '0');
                appStateContext?.dispatch({ type: "TOGGLE_DARK_MODE" });
                break;
            case 'admin-dashboard':
                navigate("/admin");
                break;
            case 'home':
                navigate("/");
                break;
            default:
                break;
        }
    }
    return (
        <>
            {(appStateContext?.state?.screenSize ?? 3) > 2 ?
                (
                    <Dropdown overlayClassName='bg-primary br-16' className='br-16 cur-pointer h-fit-content-nowrap my-auto'
                        menu={{ items, onClick: (e) => handleUserMenuClick(e.key) }} trigger={['click']} placement="bottom">
                        <div className='d-flex h-fit-content'>
                            <div className='fs14-fw400 c-default my-auto me-2 h-fit-content' style={{ alignItems: 'center' }}>{displayName}</div>
                            <DownOutlined className='c-default' />
                        </div>
                    </Dropdown>
                ) : (
                    <button onClick={() => setChangePasswordModalOpen(true)} className='my-auto'>
                        <img src={gearIcon} style={{ height: '30px', width: 'auto' }} alt="" />
                    </button>
                )

            }
            <ChangePasswordModal isOpen={changePasswordModalOpen} onCloseModal={() => { setChangePasswordModalOpen(false) }} />

        </>
    )
}

export default UserContextMenu